<template>
    <v-dialog v-model="mostrar" persistent max-width="600px">
        <v-card :loading="loading">
            <v-card-title>
            <span class="headline">Nuevo proyecto</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field 
                                v-model="numero" 
                                name="SG-NU-numero" 
                                label="Número:"
                                :error-messages="errors.numero"
                                @input="validarNumero()"
                                @blur="validarNumero()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="9">
                            <v-text-field 
                                v-model="responsable" 
                                name="SG-NU-responsable" 
                                label="Responsable:"
                                :error-messages="errors.responsable"
                                @input="validarResponsable()"
                                @blur="validarResponsable()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field 
                                v-model="nombre" 
                                name="SG-NU-nombre" 
                                label="Nombre del proyecto:"
                                :error-messages="errors.nombre"
                                @input="validarNombre()"
                                @blur="validarNombre()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field 
                                v-model="URG" 
                                name="SG-NU-URG" 
                                label="URG:"
                                :error-messages="errors.URG"
                                @input="validarURG()"
                                @blur="validarURG()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="9">
                            <v-text-field 
                                v-model="descripcionURG" 
                                name="SG-NU-descripcionURG" 
                                label="Descripción URG:"
                                :error-messages="errors.descripcionURG"
                                @input="validarDescripcionURG()"
                                @blur="validarDescripcionURG()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field 
                                v-model="fondo" 
                                name="SG-NU-fondo" 
                                label="Fondo:"
                                :error-messages="errors.fondo"
                                @input="validarFondo()"
                                @blur="validarFondo()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-model="anio" 
                                name="SG-NU-anio" 
                                label="Año:"
                                :error-messages="errors.anio"
                                @input="validarAnio()"
                                @blur="validarAnio()"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-menu
                                v-model="fechaInicioPicker"
                                :close-on-content-click="false"
                                max-width="290"
                                >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                    :value="fechaInicioTexto"
                                    label="Fecha inicio:"
                                    readonly
                                    v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="fechaInicio"
                                    locale="es"
                                    @change="fechaInicioPicker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-menu
                                v-model="fechaFinPicker"
                                :close-on-content-click="false"
                                max-width="290"
                                >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                    :value="fechaFinTexto"
                                    label="Fecha fin:"
                                    readonly
                                    v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="fechaFin"
                                    locale="es"
                                    @change="fechaFinPicker = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field 
                                v-model="montoTotal" 
                                name="SG-NU-montoTotal" 
                                label="Monto Total:"
                                prefix="$"
                                :error-messages="errors.montoTotal"
                                @input="validarMontoTotal()"
                                @blur="validarMontoTotal()"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="teal darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
            <v-btn color="teal darken-1" dark @click="guardarProyecto()">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, integer, decimal } from 'vuelidate/lib/validators'
import axios from 'axios'
import { mapGetters} from 'vuex'
import moment from 'moment'
moment.locale('es');

export default {
    props:['mostrar'],
    mixins: [validationMixin],
    data: () => ({
        loading: false,
        numero: null,
        responsable: null,
        nombre: null,
        URG: null,
        descripcionURG: null,
        fondo: null,
        anio: null,
        fechaInicioPicker: false,
        fechaInicio: moment().format('YYYY-MM-DD'),
        fechaFinPicker: false,
        fechaFin: moment().format('YYYY-MM-DD'),
        montoTotal: 0.00,
        errors:{
            numero: [],
            nombre: [],
            responsable: [],
            URG: [],
            descripcionURG: [],
            fondo: [],
            anio: []
        },
    }),
    validations: {
        numero: { required, minLength: minLength(5) },
        nombre: { required, minLength: minLength(1) },
        responsable: { required, minLength: minLength(5) },
        URG: { required },
        descripcionURG: { required },
        fondo: { required },
        anio: { required, integer, minLength: minLength(4), maxLength: maxLength(4) },
        montoTotal: { required, decimal },
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ]),
        fechaInicioTexto(){
            return this.fechaInicio ? moment(this.fechaInicio).format('DD/MM/YYYY') : ''
        },
        fechaFinTexto(){
            return this.fechaFin ? moment(this.fechaFin).format('DD/MM/YYYY') : ''
        },
    },
    methods: {
        validarNumero(){
            this.$v.numero.$touch();
            const errors = []
            if (this.$v.numero.$dirty){
                !this.$v.numero.required && errors.push('Campo requerido.')
                !this.$v.numero.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.numero = errors;
        },
        validarNombre(){
            this.$v.nombre.$touch();
            const errors = []
            if (this.$v.nombre.$dirty){
                !this.$v.nombre.required && errors.push('Campo requerido.')
            }
            this.errors.nombre = errors;
        },
        validarResponsable(){
            this.$v.responsable.$touch();
            const errors = []
            if (this.$v.responsable.$dirty){
                !this.$v.responsable.required && errors.push('Campo requerido.')
                !this.$v.responsable.minLength && errors.push('Mínimo 5 caracteres.')
            }
            this.errors.responsable = errors;
        },
        validarURG(){
            this.$v.URG.$touch();
            const errors = []
            if (this.$v.URG.$dirty){
                !this.$v.URG.required && errors.push('Campo requerido.')
            }
            this.errors.URG = errors;
        },
        validarDescripcionURG(){
            this.$v.descripcionURG.$touch();
            const errors = []
            if (this.$v.descripcionURG.$dirty){
                !this.$v.descripcionURG.required && errors.push('Campo requerido.')
            }
            this.errors.descripcionURG = errors;
        },
        validarFondo(){
            this.$v.fondo.$touch();
            const errors = []
            if (this.$v.fondo.$dirty){
                !this.$v.fondo.required && errors.push('Campo requerido.')
            }
            this.errors.fondo = errors;
        },
        validarAnio(){
            this.$v.anio.$touch();
            const errors = []
            if (this.$v.anio.$dirty){
                !this.$v.anio.required && errors.push('Campo requerido.')
                !this.$v.anio.integer && errors.push('Debe ingresar un año válido.')
                !this.$v.anio.minLength && errors.push('Debe ingresar un año válido.')
                !this.$v.anio.maxLength && errors.push('Debe ingresar un año válido.')
            }
            this.errors.anio = errors;
        },
        validarMontoTotal(){
            this.$v.montoTotal.$touch();
            const errors = []
            if (this.$v.montoTotal.$dirty){
                !this.$v.montoTotal.required && errors.push('Campo requerido.')
                !this.$v.montoTotal.decimal && errors.push('Ingrese cantidad sin caracteres especiales.')
            }
            this.errors.montoTotal = errors;
        },
        guardarProyecto(){
            this.$v.$touch();
            this.validarNumero();
            this.validarNombre();
            this.validarResponsable();
            this.validarURG();
            this.validarDescripcionURG();
            this.validarFondo();
            this.validarAnio();
            this.validarMontoTotal();
            if (!this.$v.$invalid) {
                this.loading = true;
                axios.post(this.httpURL+'/proyecto',
                {
                    numero: this.numero,
                    nombre: this.nombre,
                    responsable: this.responsable,
                    URG: this.URG,
                    descripcionURG: this.descripcionURG,
                    fondo: this.fondo,
                    anio: this.anio,
                    fechaInicio: this.fechaInicio,
                    fechaFin: this.fechaFin,
                    montoTotal: this.montoTotal
                },
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        this.$emit('proyectoAgregado',res.data.proyecto);
                        this.loading = false;
                    }else{
                        if( res.data.numero ) this.errors.numero = [res.data.mensaje];
                        if( !res.data.numero )
                            this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                        this.loading = false;
                    }
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });
            }
        }
    }
}
</script>